import { MaxWidthView } from '@flix/common/elements/layout'
import { ActivityIndicator } from '@flix/common/elements/status/ActivityIndicator/ActivityIndicator'
import LoadingSection from './LoadingSection'

export const LoadingGrid = () => (
  <MaxWidthView>
    <LoadingSection>
      <ActivityIndicator scale={1.6} />
    </LoadingSection>
  </MaxWidthView>
)

export default LoadingGrid
